<template>
  <v-card>
    <v-form @submit.prevent="checkFormValidate(saveInvoice)" ref="form"
      :disabled="isSaving || !formData || (formData && formData.isSent)">
      <v-card-text class="px-4 py-4 mb-2">
        <v-row>
          <v-col cols="6">
            <h1 class="d-inline me-5">
              {{ $t('invoice.title') }}
              <span class="text-xs" v-if="!isLoading">({{ formData.documentTypeString || documentTypeString }})</span>
            </h1>
            <br />
            <h2 class="d-inline me-5" v-if="formData && formData.documentId">
              {{ formData.documentId }}
            </h2>
            <div v-if="formData.refInvoice && formData.documentType == 6">{{ $t('invoice.reference_invoice_number') }} : {{
              formData.refInvoice.documentId }}</div>
          </v-col>
          <v-col cols="6" class="mt-2 text-right" v-if="formData">
            <v-btn color="default" elevation="2" outlined @click="dismiss()" :disabled="isSaving">{{ $t('close_window') }}</v-btn>
            <template v-if="!isLoading && !formData.isCancelled">
              <div v-if="formData.isSent" class="grouping-print-btn">
                <v-btn color="info" elevation="2" @click="printClick('th')"
                  :disabled="isSaving || isLoading || isChange">
                  <v-icon dark class="me-2">mdi-printer</v-icon>{{ $t('invoice.print_invoice') }}
                </v-btn>
              </div>
              <v-btn v-if="!formData.isSent" color="success" elevation="2" class="mx-2 my-1" type="submit"
                :disabled="!isChange || isSaving || isLoading || formData.items.length < 1">
                <v-icon dark class="me-2">mdi-content-save-all</v-icon>{{ $t('save') }}
              </v-btn>
              <v-btn v-if="!formData.isPaid && !formData.isSent && formData.documentId && formData.objectId || (!formData.isSent && formData.documentId && formData.objectId)" color="error" elevation="2" class="mx-2 my-1"
                @click="isConfrimCancelInvoice = true" :disabled="isSaving || isLoading">
                <v-icon dark class="me-2">mdi-cancel</v-icon>{{ $t('action_type.cancel') }}
              </v-btn>
              <v-btn v-if="!formData.isSent && !formData.documentId && formData.objectId" color="error" elevation="2" class="mx-2 my-1"
                @click="isConfrimRemove = true" :disabled="isSaving || isLoading">
                <v-icon dark class="me-2">mdi-delete</v-icon>{{ $t('action_type.delete') }}
              </v-btn>
              <v-btn v-if="!formData.isSent" color="primary" elevation="2" class="mx-2 my-1"
                @click="isSendConfirmDialog = true"
                :disabled="isSaving || isLoading || isChange || (invoice && invoice.isErrorBilling) || !canSend">
                <v-icon dark class="me-2">mdi-send</v-icon>{{ $t('bill.send_bill') }}
              </v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="!enableEditInvoiceAndReceipt || isContractCheckOuts('edit') ? on : null">
                    <v-btn v-if="formData.isSent && !formData.isPaid && !formData.isBadDebt" color="orange" elevation="2"
                      class="mx-2 my-1 white--text" @click="isUnsendConfirmDialog = true"
                      :disabled="isSaving || isLoading || !enableEditInvoiceAndReceipt || isContractCheckOuts('edit') || isHashPaidReceipt">
                      <v-icon dark class="me-2">mdi-clipboard-edit-outline</v-icon>{{ $t('bill.edit_bill') }}
                    </v-btn>
                  </span>
                </template>
                <span v-if="!enableEditInvoiceAndReceipt">{{ $t('validate.you_do_not_have_permission_to_edit_bill') }}</span>
                <span v-else-if="isContractCheckOuts('edit')">{{ $t('validate.cannot_do_action') }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="isContractCheckOuts() ? on : null">
                    <v-btn v-if="formData.isSent && !formData.isPaid && !formData.isBadDebt" color="success" elevation="2" class="mx-2 my-1"
                      @click="payInvoice()" :disabled="isSaving || isLoading || isContractCheckOuts()">
                      <v-icon dark class="me-2">mdi-cash-multiple</v-icon>{{ $t('payment.pay_money') }}
                    </v-btn>
                  </span>
                </template>
                <span>{{ $t('validate.cannot_do_action_because_of_moving_out') }}</span>
              </v-tooltip>
            </template>
            <!-- <v-btn
              v-if="formData.isPaid"
              color="error"
              elevation="2"
              class="mx-2 my-1"
              @click="isUnpaidConfirmDialog = true"
              :disabled="isSaving || isLoading"
            >
              <v-icon dark class="me-2"> mdi-cash-refund </v-icon
              >ยกเลิกการชำระเงิน
            </v-btn>-->
          </v-col>
        </v-row>
      </v-card-text>

      <v-card elevation="3" class="pt-5 mx-5 ps-5" v-if="!isLoading">
        <div class="card-receipt-form">
          <div class="mb-10 pe-5">
            <v-row>
              <v-col cols="12" sm="12" md="5" lg="3">
                <span>
                  <b>{{ $t('customer.company_name_and_customer_name') }}</b>
                </span>
                <v-text-field v-model="formData.customerData.name" :rules="[rules.required]"
                  :placeholder="$t('customer.company_name_and_customer_name')" class="mb-0 input-disable" outlined dense :disabled="formData.isCancelled"></v-text-field>
                <p class="mb-3">
                  <b>{{ $t('detail') }}</b>
                </p>
                <v-textarea v-model="formData.customerData.address" :placeholder="$t('address.address_detail')"
                  :label="$t('address.address_detail')" class="mb-2" outlined dense hide-details rows="2" no-resize :disabled="formData.isCancelled"></v-textarea>

                <v-row no-gutters>
                  <v-col cols="6">
                    <v-text-field v-model="formData.customerData.branchName"
                      :class="`mb-1 ${formData.customerData.taxId ? 'mt-9' : 'mt-9'}`" :placeholder="$t('address.company_branch')"
                      :label="$t('address.company_branch')" outlined dense hide-details :disabled="formData.isCancelled"></v-text-field>
                  </v-col>
                  <v-col cols="6" class="ps-1">
                    <EditTaxId v-model='formData.customerData.taxId' :customClassLabel="'d-block mb-3'"
                      :customClassWarning="'mb-2'" showWarning :showLabel='false'
                      :getIsVat="customerType == 'company' ? true : false"
                      :getIsExport="customerType == 'company' && !formData.isSent ? true : false" showPlaceholder
                      :customClassInput="'mb-2 input-disable-appearance'" :solo='false' :flat='false' outlined dense :disabled="formData.isCancelled"
                      :counter='false' :getRules="rules" @onWriteData="onWriteData"
                      @input="formData.customerData.taxId = $event" />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="formData.customerData.tel" class="mb-2" :placeholder="$t('account.phone_number')"
                      :label="$t('account.phone_number')" outlined dense hide-details :disabled="formData.isCancelled"></v-text-field>
                  </v-col>
                  <v-col cols="6" class="ps-1">
                    <v-text-field v-model="formData.customerData.email" class="mb-2" placeholder="Email" label="Email"
                      outlined dense hide-details :disabled="formData.isCancelled"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-btn v-if="formData.isSent" color="orange" elevation="2" class="my-1 white--text"
                      @click="isBillHederDialog = true" :disabled="isSaving || isLoading">
                      <v-icon dark class="me-2">mdi-clipboard-edit-outline</v-icon>{{ $t('customer.edit_customer_data') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col></v-col>
              <v-col cols="12" sm="12" md="5" lg="3">
                <InvoiceLog :invoice="invoice" v-if="invoiceId" />
                <p class="mb-0">
                  <b>{{ $t('payment.total_amount_all_payment') }}</b>
                </p>
                <h1 class="mb-7">
                  {{ formData.totalValue | currencySuffixTextThEn(formData.currencyCode) }}
                  <h4 class="d-inline red--text" v-if="formData.totalUnpaidValue && formData.totalUnpaidValue > 0 && !formData.isBadDebt">
                    {{ $t('payment.remaining') }}
                    {{ formData.totalUnpaidValue | currencySuffixTextThEn(formData.currencyCode) }}</h4>
                  <h4 class="d-inline green--text" v-if="formData.totalUnpaidValue && formData.totalUnpaidValue < 0 && !formData.isBadDebt">
                    {{ $t('over') }}
                    {{ formData.totalUnpaidValue | currencySuffixTextThEn(formData.currencyCode) }}</h4>
                </h1>
                <v-row>
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('date') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition" offset-y
                      max-width="290px" min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(invDate)" :placeholder="$t('date')" outlined dense
                          hide-details readonly v-bind="attrs" v-on="on" :disabled="formData.isCancelled"></v-text-field>
                      </template>
                      <v-date-picker v-model="invDate" no-title locale="th" @input="onChangeDate()"
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('due_date') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    <v-menu v-model="menuDueDate" :close-on-content-click="false" transition="scale-transition" offset-y
                      max-width="290px" min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(invDueDate)" :placeholder="$t('date')" outlined dense
                          hide-details readonly v-bind="attrs" v-on="on" :disabled="formData.isCancelled"></v-text-field>
                      </template>
                      <v-date-picker v-model="invDueDate" no-title locale="th" @input="menuDueDate = false"
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 3px; padding-bottom: 8px;" v-if="isErrorCreditTerm">
                  <v-col cols="5"></v-col>
                  <v-col cols="7" class="py-0 text-center">
                    <small class="warning--text">
                      <v-icon small color="warning" style="margin-top: -3px;">mdi-alert-outline</v-icon>
                      {{ $t('payment.credit_term_is', { creditTerm: creditTerm }) }}
                    </small>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('project.employee') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    <v-text-field :placeholder="$t('project.employee')" outlined dense hide-details :value="userFullName" readonly
                      :disabled="formData.isCancelled"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('payment.currency') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    <CurrencySelect 
                      v-model="formData.currencyCode" 
                      :disabled="formData.documentType == 1 || formData.isCancelled"
                      @change="onChangeCurrencyCode"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="formData.contractCheckOuts && formData.contractCheckOuts.length">
                  <v-col cols="5" class="py-0">
                    <v-subheader>
                      <b>{{ $t('market.reference_checkout') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7">
                    <template v-for="contractCheckOut in formData.contractCheckOuts">
                      <a href="#" @click="checkoutPaymentDialog(contractCheckOut)">{{ contractCheckOut.documentId
                      }}</a><br />
                    </template>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr class="my-5" />
            <v-row class="mb-0">
              <!-- <v-col cols="3">
                <v-btn
                  small
                  color="primary"
                  v-if="formData.documentType == 1"
                  @click="reCalculate()"
                >
                  <v-icon class="me-2">mdi-reload</v-icon>
                  อัพเดทบิล
                </v-btn>
              </v-col>-->
              <v-spacer></v-spacer>
              <v-col cols="3">
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-subheader>
                      <b>{{ $t('product.product_price') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-select v-model="formData.isVatInclusive" :placeholder="$t('product.product_price')" :items="[
                      {
                        text: $t('payment.price_vat_exclusive'),
                        value: false,
                      },
                      {
                        text: $t('payment.price_vat_inclusive'),
                        value: true,
                      },
                    ]" item-text="text" item-value="value" @change="onChangeIsVatInclusive()" outlined dense
                      hide-details :no-data-text="$t('noinfo')" :disabled="formData.isCancelled"></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div style="border-radius: 10px; overflow: hidden">
              <v-simple-table v-if="formData.items && formData.items.length">
                <template v-slot:default>
                  <thead class="table-item header rounded-2">
                    <tr>
                      <th width="3%" class="text-center">{{ $t('rank') }}</th>
                      <th>{{ $t('product.product_name_and_detail') }}</th>
                      <th width="8%">{{ $t('area.space') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.quantity') }}</th>
                      <th width="8%">{{ $t('unit') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.unit_price') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.discount_unit') }}</th>
                      <th width="8%">{{ $t('product.vat') }}</th>
                      <th width="8%">{{ $t('accounting_product.withholding_tax') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.total_price') }}</th>
                      <th width="4%" class="text-center" v-if="!formData.isSent"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in formData.items" :key="index">
                      <td class="py-2 text-center vertical-top">{{ index + 1 }}</td>
                      <td class="py-2">
                        <v-text-field v-if="item.billingSetting || formData.isSent || item.refInvoiceBooking" v-model="item.name"
                          :placeholder="$t('product.product_name')" outlined dense hide-details disabled></v-text-field>
                        <v-autocomplete v-else v-model="item.name" :placeholder="$t('product.product_name')"
                          :items="accountingProductOptions" :rules="[rules.required]" item-text="text" item-value="text"
                          outlined dense hide-details :menu-props="{ closeOnContentClick: true }"
                          :error="isDuplicateItem(item)" :disabled="formData.isCancelled">
                          <template v-slot:no-data>
                            <v-list-item class="d-flex justify-center">
                              {{ $t('bill.no_bill_list') }}
                            </v-list-item>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item v-if="item.isAddProduct">
                              <v-list-item-title>
                                <v-btn text color="green" block link @click="addProduct()">
                                  <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('accounting_product.add') }}
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <template v-else>
                              <v-list-item @click="chooseItem(item.obj, index)" v-show="!item.obj.isRemoved">{{
                                item.text
                              }}</v-list-item>
                            </template>
                          </template>
                        </v-autocomplete>
                        <template v-if="!formData.isSent && !item.billingSetting && isDuplicateItem(item)">
                          <p class="mb-1"><small class="red--text">{{ $t('area.have_bill_and_stall') }}</small></p>
                        </template>
                        <v-text-field v-model="item.detail" :placeholder="$t('detail')" outlined dense hide-details
                          value="detail" :disabled="item.refInvoiceBooking ? true : false || formData.isCancelled"></v-text-field>
                      </td>
                      <!-- vuetify area select -->
                      <td class="py-2 vertical-top">
                        <v-select :disabled="item.billingSetting && item.area ? true : false || formData.isCancelled" v-model="item.area" :no-data-text="$t('noinfo')"
                          :items="[{ isRemove: true, name: '-' }, ...invoiceAreas,]"
                          :item-text="(i) => (i.isRemove ? '-' : `${i.name} (${i.size || '-'}${$t('square_meter')})`)"
                          :item-value="(r) => r.isRemove ? { isRemove: true } : { className: 'Area', objectId: r.objectId, __type: 'Pointer', }"
                          outlined dense hide-details @change="chooseArea(index)" :error="isDuplicateItem(item)">
                          <template v-slot:selection="{ item }">
                            <div class="d-block w-100" style="width: 100%">
                              <v-btn text v-if="item.isRemove">-</v-btn>
                              <template v-else>
                                <div class="d-block w-100">{{ item.name }}</div>
                                <div class="d-block w-100 text-right text-gray" style="font-size: 13px">{{ `${item.size
                                  ||
                                  '-'}${$t('square_meter')}` }}</div>
                              </template>
                            </div>
                          </template>
                        </v-select>
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-currency-field 
                          :placeholder="$t('product.quantity')" 
                          class="input-right input-disable-appearance" outlined dense
                          hide-details v-model="item.quantity" 
                          @input="(value) => (item.quantity = parseFloat(item.quantity))" 
                          :rules="[rules.requiredQuantity]"
                          :disabled="item.refInvoiceBooking ? true : false || formData.isCancelled" />
                      </td>
                      <td class="py-2 vertical-top">
                        <v-text-field v-model="item.unit" :placeholder="$t('unit')" outlined dense hide-details
                          :rules="[rules.required]" :disabled="formData.isCancelled"></v-text-field>
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-currency-field 
                          v-model="item.originalPricePerUnit" 
                          :placeholder="$t('product.unit_price')"
                          class="input-right input-disable-appearance" 
                          outlined dense hide-details
                          :disabled="item.type == 'discount' || formData.isCancelled"
                          @input="(value) => (item.originalPricePerUnit = parseFloat(item.originalPricePerUnit))"
                          :options="{ precision: {}}"
                        />
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-menu v-if="item.type != 'discount'" offset-y style="max-width: 600px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-currency-field 
                              v-model="item.discountPerUnit" 
                              :placeholder="$t('product.discount_per_unit_price')"
                              class="input-right input-disable-appearance" outlined dense hide-details 
                              @input="(value) => (item.discountPerUnit = parseFloat(item.discountPerUnit))"
                              :suffix="item.discountType == 2 ? '%' : ''" v-bind="attrs" v-on="on"
                              :rules="item.discountType == 2 ? [rules.maxDiscountPercent] : []"
                              :disabled="formData.isCancelled"
                            />
                          </template>
                          <v-card>
                            <v-card-title class="px-3 py-2">
                              <h5 class="my-0">{{ $t('product.select_discount_type') }}</h5>
                            </v-card-title>
                            <v-card-text class="px-4 py-0">
                              <v-radio-group v-model="item.discountType" class="my-0 py-0 small-radio" column>
                                <v-radio :label="$helper.currencyThEn(formData.currencyCode)" :value="1"></v-radio>
                                <v-radio :label="$t('percent')" :value="2"></v-radio>
                              </v-radio-group>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                        <v-currency-field v-else 
                          v-model="item.discountPerUnit"
                          :placeholder="$t('product.discount_per_unit_price')"
                          class="input-right input-disable-appearance" outlined dense hide-details
                          @input="(value) => (item.discountPerUnit = parseFloat(item.discountPerUnit))"
                          :disabled="item.refInvoiceBooking ? true : false || formData.isCancelled"
                        />
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-select v-model="item.sellVatType" :items="[
                          {
                            text: `${formData.vatPercent}%`,
                            value: 1,
                          },
                          {
                            text: '0%',
                            value: 2,
                          },
                          {
                            text: $t('except'),
                            value: 3,
                          },
                        ]" item-text="text" item-value="value" :placeholder="$t('product.unit_price')" outlined dense
                          hide-details :no-data-text="$t('noinfo')" :disabled="formData.isCancelled"></v-select>
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-select v-model="item.whtPercent" :items="taxWithheldOptions" item-text="name"
                          item-value="value" :placeholder="$t('product.withholding')" outlined lang hide-details :no-data-text="$t('noinfo')" :disabled="formData.isCancelled">
                          <template v-slot:selection="data">
                            <div class="d-block w-100" style="width: 100%">
                              <template v-if="data.item.value > 0">
                                <div class="d-block w-100">
                                  {{ item.totalWhtValue | currency }}
                                  <br />
                                </div>
                              </template>
                              <div class="d-block w-100" :style="data.item.value > 0 ? 'font-size: 13px' : ''"
                                :class="data.item.value > 0 ? 'text-right text-gray' : ''">
                                {{ data.item.name }}
                              </div>
                            </div>
                          </template>
                        </v-select>
                      </td>
                      <td class="py-4 text-right vertical-top">
                        <b>{{ item.totalOriginalValue | currency }}</b>
                      </td>
                      <td class="text-center" v-if="!formData.isSent">
                        <v-icon class="mr-2" color="error" @click="deleteItem(index)"
                          :disabled="isSaving || formData.isCancelled">mdi-trash-can-outline</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <div class="px-5 py-3">
              <v-btn class="mx-2" color="primary" elevation="2" outlined @click="addItem()"
                :disabled="isSaving || formData.isSent || formData.isCancelled">
                <v-icon dark class="me-2">mdi-plus</v-icon>{{ $t('area.add_line_list') }}
              </v-btn>
              <v-btn class="mx-2" color="primary" elevation="2" outlined @click="isAddItemAreasDialog = true"
                :disabled="isSaving || formData.isSent || formData.isCancelled">
                <v-icon dark class="me-2">mdi-plus-box-multiple-outline</v-icon>{{ $t('area.add_multiple_stall') }}
              </v-btn>
              <v-btn v-if="formData.documentType == 4" class="mx-2" color="primary" elevation="2" outlined
                @click="isLastMeterDialog = true" :disabled="isSaving || formData.isSent || formData.isCancelled">
                <v-icon dark class="me-2">mdi-calculator-variant</v-icon>{{ $t('payment.water_and_electricity_last') }}
              </v-btn>
              <template v-if="formData.documentType == 2">
                <v-btn
                  v-if="!isSaving && !formData.isSent && bookingAreaCustomerInvoices && bookingAreaCustomerInvoices.length > 0"
                  class="mx-2" color="primary" elevation="2" outlined @click="isUsedAsADiscountDialog = true"
                  :disabled="formData.isCancelled">
                  <v-icon dark class="me-2">mdi-percent-box</v-icon>{{ $t('booking.booking_bill_discount') }}
                </v-btn>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="inline">
                      <v-btn class="mx-2" color="primary" elevation="2" outlined disabled>
                        <v-icon dark class="me-2">mdi-percent-box</v-icon>{{ $t('booking.booking_bill_discount') }}
                      </v-btn>
                    </div>
                  </template>
                  <div>{{ $t('booking.no_booking_bill_in_this_stall') }}</div>
                </v-tooltip>
              </template>
            </div>
            <v-row class="px-5 mt-3 mb-0">
              <v-col cols="4">
                <span>
                  <b>{{ $t('note') }}:</b>
                </span>
                <v-textarea v-model="formData.note" :placeholder="$t('note')" outlined dense hide-details rows="2"
                  no-resize :disabled="formData.isCancelled"></v-textarea>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="3" class="pe-5">
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('payment.total_amount') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalOriginalValue | currencySuffixTextThEn(formData.currencyCode)
                    }}</p>
                  </v-col>
                </v-row>
                <hr class="my-4" />
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('payment.total_discount_amount_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalDiscountValue | currencySuffixTextThEn(formData.currencyCode)
                    }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_exempt_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalNonVatItemsValue |
                      currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_calculated_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalVatItemsValue | currencySuffixTextThEn(formData.currencyCode)
                    }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_vat') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalVatValue | currencySuffixTextThEn(formData.currencyCode) }}
                    </p>
                  </v-col>
                </v-row>
                <hr class="my-4" />
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic bold">{{ $t('market.total_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number bold">{{ formData.totalValue | currencySuffixTextThEn(formData.currencyCode) }}
                    </p>
                  </v-col>
                </v-row>
                <div v-if="isWht">
                  <hr class="my-4" />
                  <v-row>
                    <v-col cols="7" class="py-0">
                      <p class="summary-topic">{{ $t('tax.tax_withholding') }}</p>
                    </v-col>
                    <v-col cols="5" class="py-0 text-right">
                      <p class="summary-number">{{ formData.totalWhtValue | currencySuffixTextThEn(formData.currencyCode) }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="py-0">
                      <p class="summary-topic bold">{{ $t('payment.total_amount_to_pay') }}</p>
                    </v-col>
                    <v-col cols="5" class="py-0 text-right">
                      <p class="summary-number bold">
                        {{
                          (formData.totalValue - formData.totalWhtValue)
                          | currencySuffixTextThEn(formData.currencyCode)
                        }}
                      </p>
                    </v-col>
                  </v-row>
                </div>
                <hr class="mt-4" />
                <hr class="mt-1" />
              </v-col>
            </v-row>
            <v-card class="pb-3 my-10 ms-1"
              v-if="invoice && invoice.invoicePayment && invoice.isSent && !invoice.isPaid">
              <v-card-text>
                <h2 class="py-0 green--text">{{ $t('payment.notify_payment') }}</h2>
              </v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="6" class>
                    <a v-for="(img, index) in invoice.invoicePayment.paymentProofFiles"
                      class="w-100 flex items-center justify-center mb-3" :key="index" :href="img.url" target="_blank">
                      <v-img max-width="500" :src="img.url" />
                    </a>
                  </v-col>
                  <v-col cols="6" v-if="invoice.invoicePayment.paymentBankAccount" style="font-size: 18px">
                    <h3 class="mb-5">
                      <b>{{ $t('payment.transfer_to_account') }}</b>
                    </h3>
                    <p>
                      <b>{{ $t('payment.bank') }} :</b>
                      <img style="display: inline;border-radius: 50%;" width="40"
                        :src="require(`../assets/images/bank/${invoice.invoicePayment.paymentBankAccount.bankCode}.jpg`)" />
                      {{ BankData[invoice.invoicePayment.paymentBankAccount.bankCode].name }}
                    </p>
                    <p>
                      <b>{{ $t('payment.account_number') }} :</b>
                      {{ invoice.invoicePayment.paymentBankAccount.accountName }}
                    </p>
                    <p>
                      <b>{{ $t('payment.account_name') }} :</b>
                      {{ invoice.invoicePayment.paymentBankAccount.accountNumber }}
                    </p>

                    <br />

                    <p>
                      <b>{{ $t('payment.attached_when') }} :</b>
                      {{ $moment(invoice.invoicePayment.createdAt).format("lll") }}
                    </p>
                    <p>
                      <b>{{ $t('payment.attached_by') }} :</b>
                      {{ invoice.invoicePayment.customerUser.user.firstName }} {{
                        invoice.invoicePayment.customerUser.user.lastName }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="isCacelPaymentProofDialog = true" color="error">{{ $t('payment.cancel_notify_payment') }}</v-btn>
              </v-card-actions>
            </v-card>
            <v-card class="pb-3 my-10 ms-1">
              <v-card-text>
                <h3 class="py-0 green--text">{{ $t('payment.save_payment') }}</h3>
              </v-card-text>
              <div class="px-5">
                <v-simple-table>
                  <template v-slot:default>
                    <thead class="table-item header rounded-2">
                      <tr>
                        <th>{{ $t('bill.receipt_id') }}</th>
                        <th>{{ $t('payment.pay_date') }}</th>
                        <th class="text-right">{{ $t('payment.net_amount') }}</th>
                        <th class="text-right">{{ $t('tax.tax_withholding') }}</th>
                        <th class="text-right">{{ $t('payment.received_amount') }}</th>
                        <th class="text-center">{{ $t('payment.payment_method') }}</th>
                        <th width="10%">{{ $t('status') }}</th>
                        <th width="10%">{{ $t('note') }}</th>
                        <th width="10%"></th>
                      </tr>
                    </thead>
                    <tbody v-if="receipts && !isLoading && !isSaving">
                      <tr v-for="receipt in receipts" :key="receipt.objectId" @click="viewReceipt(receipt)">
                        <td>
                          <div class="d-flex align-center">
                            <img v-if="receipt.refAccId && receipt.isPaid" class="me-1" width="18"
                              :src="require(`@/assets/images/flowaccount.svg`)" />
                            {{ receipt.documentId }}
                          </div>
                        </td>
                        <td>{{ `${$moment(receipt.date).format("D/MM/YYYY")}` }}</td>
                        <td class="text-right">{{ receipt.totalValue | currencyPrefixSign(receipt.currencyCode) }}</td>
                        <td class="text-right">{{ receipt.totalWhtValue | currencyPrefixSign(receipt.currencyCode) }}</td>
                        <td class="text-right">
                          {{
                            (receipt.totalValue - receipt.totalWhtValue)
                            | currencyPrefixSign(receipt.currencyCode)
                          }}
                        </td>
                        <td class="text-center">
                          <span v-if="receipt.paymentMethod == 1">{{ $t('payment.cash') }}</span>
                          <span v-if="receipt.paymentMethod == 2">
                            {{ $t('payment.bank_transfer_money') }}
                            <br />
                            [{{
                              BankData[receipt.paymentBankAccount.bankCode]
                                .name
                            }}]
                            <br />
                            [{{ $t('number') }}:{{
                              receipt.paymentBankAccount.accountNumber
                            }}]
                            <br />
                            <template v-for="(img, index) of receipt.paymentProofFiles">
                              <a :href="img.url" target="_blank" :key="`img_${index}`" @click.stop>{{ $t('customer.proof_number', { index: index + 1 }) }}</a>
                            </template>
                          </span>
                          <span v-if="receipt.paymentMethod == 3">{{ $t('payment.credit_card') }}</span>
                          <span v-if="receipt.paymentMethod == 4">{{ $t('payment.bill_payment') }}</span>
                          <span v-if="receipt.paymentMethod == 5">{{ $t('payment.deposit_deduction') }}</span>
                          <span v-if="receipt.paymentMethod == 6">
                            {{ $t('payment.cash_check') }}
                            <br />
                            [{{
                              BankData[receipt.paymentBankAccount.bankCode]
                                .name
                            }}]
                            <br />
                            [{{ $t('number') }}:{{
                              receipt.paymentBankAccount.accountNumber
                            }}]
                            <br />
                          </span>
                          <span v-if="receipt.paymentMethod == 7">QR Payment</span>
                          <span v-if="receipt.paymentMethod == 8">
                            {{ $t('payment.gift_voucher') }}
                            <span v-if="receipt.voucherNumber">
                              <br />
                              [{{ $t('number') }}:{{ receipt.voucherNumber }}]
                            </span>
                            <br />
                            <template v-for="(img, index) of receipt.paymentProofFiles">
                              <a :href="img.url" target="_blank" @click.stop>{{ $t('customer.proof_number', { index: index + 1 }) }}</a>
                            </template>
                          </span>
                        </td>
                        <td>
                          <span v-if="receipt.isPaid" class="green--text">{{ $t('payment.paid') }}</span>
                          <span v-if="!receipt.isPaid && !receipt.documentId" class="red--text">{{ $t('payment.pending') }}</span>
                          <span v-if="!receipt.isPaid && receipt.documentId" class="red--text">{{ $t('payment.cancel_payment') }}</span>
                        </td>
                        <td>
                          <span v-if="receipt.paymentNote"> {{ receipt.paymentNote }} </span>
                          <div v-if="!receipt.isPaid && receipt.cancelledNote" class="red--text"> {{ $t('cancel') }}: {{
                            receipt.cancelledNote }}
                          </div>
                        </td>
                        <td class="text-center">
                          <template>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="isContractCheckOuts() ? on : null">
                                  <v-btn v-if="!receipt.isPaid" color="success" elevation="2"
                                    class="mx-2 my-1" @click.stop="payReceipt(receipt)"
                                    :disabled="isSaving || isLoading || isContractCheckOuts() || !formData.isSent || formData.isBadDebt">{{ $t('payment.pay_money') }}</v-btn>
                                </span>
                              </template>
                              <span>{{ $t('validate.cannot_do_action_because_of_moving_out') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs"
                                  v-on="!enableEditInvoiceAndReceipt || isContractCheckOuts() ? on : null">
                                  <v-btn v-if="receipt.isPaid" color="error" elevation="2" class="mx-2 my-1"
                                    @click.stop="unpaidReceip(receipt)"
                                    :disabled="isSaving || isLoading || !enableEditInvoiceAndReceipt || isContractCheckOuts() || formData.isBadDebt">
                                    {{ $t('payment.cancel_payment') }}</v-btn>
                                </span>
                              </template>
                              <span v-if="!enableEditInvoiceAndReceipt">{{ $t('validate.you_do_not_have_permission_to_edit_bill') }}</span>
                              <span v-else-if="isContractCheckOuts()">{{ $t('validate.cannot_do_action_because_of_moving_out') }}</span>
                            </v-tooltip>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <div class="py-5 text-center" v-if="!formData.receipts ||
                  (formData.receipts && !formData.receipts.length)
                ">--- {{ $t('payment.no_payment') }} ---</div>
              </div>
            </v-card>
          </div>
        </div>
      </v-card>
      <v-card class="justify-center py-10 d-flex" v-if="isLoading">
        <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
      </v-card>
    </v-form>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <v-snackbar v-model="isCancelSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('cancel_success') }}
    </v-snackbar>
    <ConfirmDialog v-model="isConfirmDialog" :title="$t('validate.you_want_to_save_data')" :textBtnOk="$t('save_and_close')"
      :textBtnCancel="$t('not_save_and_close')" @onOk="checkFormValidate(onOkConfirmDialog)" @onCancel="onCancelConfirmDialog" />
    <ConfirmDialog v-model="isSendConfirmDialog" :title="$t('validate.you_want_to_send_bill')" :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('close')" @onOk="onOkSendConfirmDialog" @onCancel="isSendConfirmDialog = false" />
    <ConfirmDialog v-model="isUnsendConfirmDialog" :title="$t('validate.you_want_to_cancel_send_bill')" :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('close')" type="error" @onOk="onOkUnsendConfirmDialog" />
    <ConfirmDialog v-model="isUnpaidConfirmDialog"
      :title="`${$t('validate.you_want_to_cancel_payment', { action: tempReceipt && tempReceipt.paymentMethod == 7 ? $t('payment.and_refund') : '' })}`"
      :text="`${$t('validate.you_want_to_cancel_payment_question')}`" :isNote="true" :textBtnOk="$t('confirm')" :textBtnCancel="$t('cancel')" type="error"
      @onOk="onOkUnpaidConfirmDialog" />
    <AccountingProductManageDialog v-model="isDialogAccountingProduct" :projectId="projectId"
      @onSaveSuccess="isSuccess = true" @onError="isError = true" />
    <PaymentFormDialog v-if="invoice" v-model="isPaymentFormDialog" :projectId="projectId" :invoice="tempInvoice"
      :receipt="tempReceipt" :paymentMethod="tempInvoicePayment ? tempInvoicePayment.paymentMethod : null"
      :paymentProofFiles="tempInvoicePayment ? tempInvoicePayment.paymentProofFiles : null"
      :paymentBankAccount="tempInvoicePayment ? tempInvoicePayment.paymentBankAccount : null"
      :receipts="receipts ? receipts : null" @onSaveSuccess="onSaveSuccessPayment" />
    <ReceiptDialog v-if="tempReceipt" v-model="isReceiptDialog" :projectId="projectId"
      :receiptId="tempReceipt.objectId" />
    <PrintDialog elementId="print-invoice-form" type="invoice" v-if="formData && formData.objectId"
      v-model="isPrintDialog" :invoiceIds="[formData.objectId]" :lang="printLang" />
    <LastMeterDialog v-model="isLastMeterDialog" :areaIds="invoiceAreas.map(d => d.objectId)" @onSuccess="addItems" />
    <ConfirmDialog v-model="isConfrimRemove" :title="$t('validate.you_want_to_delete_bill')" :textBtnOk="$t('confirm')" :textBtnCancel="$t('close')"
      type="error" @onOk="onOkRemoveConfirmDialog" />
    <ConfirmDialog v-model="isConfrimCancelInvoice" :title="$t('validate.you_want_to_cancel_bill')" :textBtnOk="$t('confirm')" :textBtnCancel="$t('close')"
      type="error" @onOk="onOkCancelInvoice" />
    <BillHederDialog v-if="invoice" v-model="isBillHederDialog" :invoiceId="invoice.objectId"
      :customerType="customerType" :customerData="formData.customerData" @onSaveSuccess="onSaveSuccessBillHeder" />
    <ConfirmDialog v-model="isCacelPaymentProofDialog" :title="$t('validate.confirm_cancel_payment')" :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('close')" type="error" @onOk="onCancelInvoicePayment" />
    <ChooseAccountingProductAndAreas v-model="isAddItemAreasDialog" :accountingProducts="accountingProducts"
      :areas="invoiceAreas" @onSuccess="onSuccessChooseProductAndAreas"/>
    <ChooseAccountingProductAndInvoice v-if="formData && formData.documentType == 2" v-model="isUsedAsADiscountDialog"
      :contractData="contractData" :currencyCode="formData.currencyCode" @onSuccess="onSuccessChooseAccountingProductAndInvoice" />
    <ConfirmDialog v-model="isConfirmSaveDialog"
      :text="`${$t('invoice.have_item_price_or_discount_is_zero')} ${$helper.currencyThEn(formData.currencyCode || 'THB')}`"
      :title="$t('validate.you_want_to_save_data')" :textBtnOk="$t('confirm')" :textBtnCancel="$t('not_save')" @onOk="tempCallbackFunc()"
      @onCancel="isConfirmSaveDialog = false" />
    <CheckoutPayment v-model="isCheckoutPayment" @onSuccess="initData()" @onSuccessCheckout="initData()"
      :isCreate="true" :isHideActions="true" :objectId="tempCheckout ? tempCheckout.objectId : null" />
  </v-card>
</template>

<script>
import { DocumentItem, Invoice, Receipt, Market, Contract } from "../classes";
import { mapState, mapGetters, mapActions } from "vuex";
import AccountingProductManageDialog from "@/components/AccountingProductManageDialog.component";
import ConfirmDialog from "@/components/ConfirmDialog.component";
import InvoiceLog from "@/components/InvoiceLog.component";
import PaymentFormDialog from "../components/paymentFormDialog.component";
import BankData from "../json/bank-data.json";
import ReceiptDialog from "../components/ReceiptDialog.component.vue";
import PrintDialog from "../components/PrintDialog.component.vue";
import LastMeterDialog from "../components/LastMeterDialog.component.vue";
import BillHederDialog from "../components/BillHederDialog.vue";
import ChooseAccountingProductAndAreas from "../components/ChooseAccountingProductAndAreas.vue";
import ChooseAccountingProductAndInvoice from "../components/ChooseAccountingProductAndInvoice.vue";
import EditTaxId from "@/components/EditTaxId.vue";
import CurrencySelect from "@/components/CurrencySelect.vue";

export default {
  props: {
    invoiceId: String,
    projectId: String,
    documentType: Number,
    contractData: Object,
    bookingId: String,
    canSend: Boolean
  },
  components: {
    AccountingProductManageDialog,
    ConfirmDialog,
    InvoiceLog,
    PaymentFormDialog,
    ReceiptDialog,
    PrintDialog,
    LastMeterDialog,
    BillHederDialog,
    ChooseAccountingProductAndAreas,
    ChooseAccountingProductAndInvoice,
    EditTaxId,
    CurrencySelect,
    CheckoutPayment: () => import('@/components/CheckoutPayment.vue')
  },
  data() {
    return {
      market: null,
      formData: {},
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        requiredQuantity: value => !!value || value == 0 || this.$t('validate.please_input_data'),
        texId: value => !value || value.length == 0 || value.length == 13 || this.$t('validate.please_input_data_correct_thirteen_digit'),
        maxDiscountPercent: v => v <= 100 || this.$t('validate.please_max_percent'),
        numbersOnly: value => !value || /^\d+$/.test(value) || this.$t('validate.numbers_only'),
      },
      isLoading: false,
      menuDate: false,
      menuDueDate: false,
      tempFormData: null,
      isSaving: false,
      isError: false,
      isSuccess: false,
      isDialogAccountingProduct: false,
      isConfirmDialog: false,
      isPaymentFormDialog: false,
      isUnsendConfirmDialog: false,
      isUnpaidConfirmDialog: false,
      receipts: null,
      BankData: BankData,
      isSendConfirmDialog: false,
      tempInvoice: null,
      tempReceipt: null,
      isReceiptDialog: false,
      isPrintDialog: false,
      printLang: 'th',
      invDate: this.$moment().toISOString(),
      invDueDate: this.$moment()
        .add(7, "days")
        .toISOString(),
      project: null,
      invoiceAreas: [],
      isLastMeterDialog: false,
      customerType: null,
      isConfrimRemove: false,
      isBillHederDialog: false,
      tempInvoicePayment: null,
      isCacelPaymentProofDialog: false,
      isCancelSuccess: false,
      isAddItemAreasDialog: false,
      isUsedAsADiscountDialog: false,
      contractAreas: [],
      isConfirmSaveDialog: false,
      isCheckoutPayment: false,
      tempCheckout: null,
      taxWithheldOptions: [
        {
          name: this.$t('no'),
          value: 0
        },
        {
          name: "0.75%",
          value: 0.75
        },
        {
          name: "1%",
          value: 1
        },
        {
          name: "1.5%",
          value: 1.5
        },
        {
          name: "2%",
          value: 2
        },
        {
          name: "3%",
          value: 3
        },
        {
          name: "5%",
          value: 5
        },
        {
          name: "10%",
          value: 10
        },
        {
          name: "15%",
          value: 15
        }
      ],
      creditTerm: 7,
      isConfrimCancelInvoice: false
    };
  },
  computed: {
    documentTypeString() {
      const type = this.documentType || this.formData.documentType;
      this.reCalculateCreate();
      return type == 2
        ? this.$t('bill.document_type.2')
        : type == 3
          ? this.$t('bill.document_type.3')
          : type == 4
            ? this.$t('bill.document_type.4')
            : type == 5
              ? this.$t('bill.document_type.5')
              : type == 7
                ? this.$t('bill.document_type.7')
                : type == 8
                  ? this.$t('bill.document_type.8')
                  : this.$t('bill.document_type.1');
    },
    ...mapGetters({
      areaByBooking: "booking/getAreas",
      booking: "booking/getBooking",
      getMarketId: "markets/getMarketId",
      bookingAreaCustomerInvoices: "booking/getBookingAreaCustomerInvoices"
    }),
    ...mapState({
      invoice: state => state.invoice.invoice,
      accountingProducts: state => state.accountingProducts.accountingProducts,
      areaAccountingProducts: state =>
        state.areaAccountingProduct.areaAccountingProducts
    }),
    accountingProductOptions() {
      let _accountingProducts = this.accountingProducts?.map(d => {
        return {
          text: `${d.name}`,
          value: `${d.name}`,
          obj: d
        };
      }) || []
      if (this.admin || this.employee && this.employee.enableAddAccountingProduct) _accountingProducts.push({ isAddProduct: true })
      return _accountingProducts
    },
    user() {
      return this.$store.getters["user/getUser"];
    },
    userFullName() {
      if (this.invoice) {
        if (!this.invoice.isSent) {
          return `${this.user.firstName || ""} ${this.user.lastName || ""}`;
        } else {
          if (this.invoice.createdByFullName)
            return this.invoice.createdByFullName;
          else
            return `${this.user.firstName || ""} ${this.user.lastName || ""}`;
        }
      } else {
        return `${this.user.firstName || ""} ${this.user.lastName || ""}`;
      }
    },
    isChange() {
      return JSON.stringify(this.formData) !== this.tempFormData;
    },
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.$route.params.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.$route.params.marketId);
    },
    isWht() {
      return this.formData.items.filter(d => d.whtPercent > 0).length > 0;
    },
    enableEditInvoiceAndReceipt() {
      let res = false;
      if (
        this.admin ||
        (this.admins && this.admins.length) ||
        (this.employee && this.employee.enableEditInvoiceAndReceipt)
      ) {
        res = true;
      }
      return res;
    },
    isDisableCreditTerm() {
      const type = this.documentType || this.formData.documentType;
      return type == 8 || type == 7
    },
    isErrorCreditTerm() {
      if (!this.isDisableCreditTerm) {
        if (this.$moment(this.invDueDate).endOf("day").diff(this.$moment(this.invDate).endOf("day"), "days") != this.creditTerm) {
          return true
        } else {
          return false
        }
      }
    },
    isHashPaidReceipt() {
      return this.receipts.filter(d => d.isPaid).length > 0
    }
  },
  async created() {
    this.isLoading = true;
    try {
      if (this.admins && this.admins.length) {
        this.project = this.admins[0].project;
      }
      if (this.employees && this.employees.length) {
        this.project = this.employees[0].project;
      }
      await this.$store.dispatch(
        "accountingProducts/getAccountingProducts",
        this.projectId
      );
      if (this.invoice && this.invoice.items && this.invoice.items.length) {
        let productIdList = [
          ...new Set([
            ...this.invoice.items
              .filter(
                d =>
                  d.accountingProduct &&
                  this.accountingProducts.findIndex(
                    i => i.objectId === d.accountingProduct.objectId
                  ) == -1
              )
              .map(x => x.accountingProduct.objectId)
          ])
        ];
        await this.$store.dispatch(
          "accountingProducts/getAccountingProductsByIds",
          productIdList
        );
      }
      await this.initData();
      this.isLoading = false;
    } catch (error) {
      console.log("error inv", error);
      this.isLoading = false;
      this.isError = true;
    }
  },
  methods: {
    ...mapActions({
      getContractCheckout: "contractCheckout/getContractCheckout",
    }),
    async initData() {
      try {
        if (this.admins && this.admins.length) {
          this.project = this.admins[0].project;
        }
        if (this.employees && this.employees.length) {
          this.project = this.employees[0].project;
        }
        this.$store.commit("invoice/setInvoice", null);
        if (
          (this.documentType == 7 || this.documentType == 8) &&
          this.bookingId
        ) {
          await this.$store.dispatch("booking/getBooking", this.bookingId);
        }
        this.receipts = null;
        if (
          this.invoiceId ||
          this.formData.objectId ||
          ((this.documentType == 7 || this.documentType == 8) &&
            this.bookingId &&
            this.invoiceId)
        ) {
          const invoice = await this.$store.dispatch("invoice/getById", {
            invoiceId: this.invoiceId || this.formData.objectId,
            marketId: this.getMarketId || this.$route.params.marketId,
            projectId: this.projectId
          });
          if (
            (invoice.documentType == 7 || invoice.documentType == 8) &&
            invoice.booking
          ) {
            await this.$store.dispatch(
              "booking/getBooking",
              invoice.booking.objectId
            );
            this.contractAreas = this.areaByBooking;
          } else {
            if (invoice.contract && invoice.contract.areas) {
              this.contractAreas = invoice.contract.areas
            }
          }
          this.receipts = await Receipt.getReceiptsByInvoice(
            this.invoice.objectId
          );
          this.formData = this.invoice;
          if (this.formData.date)
            this.invDate = this.$moment(this.formData.date).toISOString();
          if (this.invoice.contract && this.invoice.contract.customer)
            this.customerType = this.invoice.contract.customer.type;
          // creditTerm
          if (invoice.contract && invoice.contract.creditTerm) {
            this.creditTerm = invoice.contract.creditTerm;
          } else {
            this.market = await Market.getMarket(invoice.market.objectId);
            if (this.market && this.market.creditTerm) {
              this.creditTerm = this.market.creditTerm;
            }
          }
          if (this.formData.dueDate) {
            this.invDueDate = this.$moment(this.formData.dueDate).toISOString();
          } else {
            this.invDueDate = this.$moment()
              .add(this.creditTerm, "days")
              .toISOString();
          }
        } else if (this.contractData) {
          this.formData = new Invoice({
            customerData: this.contractData.billingData,
            items: [],
            date: this.$moment().toISOString(),
            dueDate: this.$moment()
              .add(this.creditTerm, "days")
              .toISOString(),
            isVatInclusive: this.project ? this.project.isVatInclusive : false,
            note: "",
            projectCode: this.project ? this.project.code : null
          });
          if (this.contractData.customer)
            this.customerType = this.contractData.customer.type;

          // creditTerm
          if (this.contractData && this.contractData.objectId) {
            let contract = await Contract.getContract({
              id: this.contractData.objectId
            })
            if (contract && contract.areas) {
              this.contractAreas = contract.areas
            }
            if (contract && contract.creditTerm) {
              this.creditTerm = contract.creditTerm;
              this.invDueDate = this.$moment()
                .add(this.creditTerm, "days")
                .toISOString();
            } else {
              this.market = await Market.getMarket(
                this.contractData.market.objectId
              );
              if (this.market && this.market.creditTerm) {
                this.creditTerm = this.market.creditTerm;
                this.invDueDate = this.$moment()
                  .add(this.creditTerm, "days")
                  .toISOString();
              }
            }
          } else if (this.booking && this.booking.market) {
            this.contractAreas = this.areaByBooking;
            this.market = await Market.getMarket(this.booking.market.objectId);
            if (this.market && this.market.creditTerm) {
              this.creditTerm = this.market.creditTerm;
              this.invDueDate = this.$moment()
                .add(this.creditTerm, "days")
                .toISOString();
            }
          }
        } else {
          this.formData = new Invoice({
            items: [],
            date: this.$moment().toISOString(),
            dueDate: this.$moment()
              .add(this.creditTerm, "days")
              .toISOString(),
            isVatInclusive: this.project ? this.project.isVatInclusive : false,
            projectCode: this.project ? this.project.code : null
          });
          this.customerType = null;
        }
        this.formData.sentBy = {
          className: "_User",
          objectId: this.user.objectId,
          __type: "Pointer"
        };
        this.invoiceAreas = [];
        let temps = [
          ...(this.contractAreas ? this.contractAreas : []),
          ...(this.invoice ? this.invoice.items.map(d => d.area) : [])
        ];
        for (let area of temps) {
          if (
            area &&
            this.invoiceAreas.findIndex(d => d.objectId == area.objectId) == -1
          ) {
            this.invoiceAreas.push(area);
          }
        }
        this.invoiceAreas = this.invoiceAreas.sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        await this.$store.dispatch(
          "areaAccountingProduct/getAreaAccountingProductByAreas",
          this.invoiceAreas.map(d => d.objectId)
        );
        if (this.documentType && !this.invoice) this.formData.documentType = this.documentType;
        this.tempFormData = JSON.stringify(this.formData);
        if (!this.formData.isSent) {
          for (let [index, item] of this.formData.items.entries()) {
            if (item.accountingProduct?.objectId) {
              let product = this.accountingProducts.find(
                d => d.objectId == item.accountingProduct.objectId
              );
              if (product) {
                this.formData.items[index].name = product.name;
              }
            }
          }
        }
      } catch (error) {
        throw error;
      }
    },
    onChangeIsVatInclusive() {
      for (let item of this.formData.items) {
        item.setMainIsVatInclusive = this.formData.isVatInclusive;
      }
    },
    preparePostData() {
      let postData = {};
      if (this.booking) postData.marketId = this.booking.market.objectId;
      postData.id = this.formData.objectId;
      postData.contractId = this.contractData
        ? this.contractData.objectId
        : null;
      postData.customerData = this.formData.customerData || {};
      postData.type = this.documentType || 1;
      postData.items = this.formData.items.map(d => {
        let obj = {};
        if (d.area) {
          if (!d.area.isRemove) {
            obj.area = d.area;
          }
        }
        if (d.meter) obj.meter = d.meter;
        if (d.billingSetting) obj.billingSetting = d.billingSetting;
        if (d.accountingProduct) obj.accountingProduct = d.accountingProduct;
        if (d.refInvoiceBooking) obj.refInvoiceBooking = {
          className: "Invoice",
          objectId: d.refInvoiceBooking.objectId,
          __type: "Pointer"
        }
        obj.name = d.name;
        obj.detail = d.detail;
        obj.unit = d.unit;
        obj.quantity = d.quantity;
        obj.originalPricePerUnit = d.originalPricePerUnit;
        obj.sellVatType = d.sellVatType;
        obj.whtPercent = d.whtPercent;
        obj.totalValue = d.totalValue;
        obj.totalVatValue = d.totalVatValue;
        obj.totalNonVatValue = d.totalNonVatValue;
        obj.totalWhtValue = d.totalWhtValue;
        obj.type = d.type;
        obj.discountType = d.discountType;
        obj.discountPerUnit = d.discountPerUnit;
        obj.originalDiscountPerUnit = d.originalDiscountPerUnit;
        obj.totalDiscountValue = d.totalDiscountValue;
        obj.totalDiscountVatValue = d.totalDiscountVatValue;
        obj.totalDiscountNonVatValue = d.totalDiscountNonVatValue;
        return obj;
      });
      postData.totalValue = this.formData.totalValue;
      postData.totalVatValue = this.formData.totalVatValue;
      postData.totalNonVatValue = this.formData.totalNonVatValue;
      postData.totalVatItemsValue = this.formData.totalVatItemsValue;
      postData.totalNonVatItemsValue = this.formData.totalNonVatItemsValue;
      postData.totalWhtValue = this.formData.totalWhtValue;
      postData.totalDiscountValue = this.formData.totalDiscountValue;
      postData.totalDiscountVatValue = this.formData.totalDiscountVatValue;
      postData.totalDiscountNonVatValue = this.formData.totalDiscountNonVatValue;
      postData.isVatInclusive = this.formData.isVatInclusive;
      postData.currencyCode = this.formData.currencyCode;
      postData.note = this.formData.note;
      postData.date = this.invDate
        ? this.$moment(this.invDate)
          .startOf("day")
          .toDate()
        : null;
      postData.dueDate = this.invDueDate
        ? this.$moment(this.invDueDate)
          .endOf("day")
          .toDate()
        : null;
      for (const item of this.formData.items) {
        if (item.refInvoiceBooking) {
          if (!postData.refInvoiceBooking) postData.refInvoiceBooking = []
          postData.refInvoiceBooking.push(item.refInvoiceBooking.objectId)
        }
      }
      if (this.formData.refInvoiceBooking?.length && !postData.refInvoiceBooking) {
        postData.refInvoiceBooking = []
      }
      return postData;
    },
    async saveInvoice() {
      if (this.$refs.form.validate()) {
        this.isSaving = true;
        try {
          let postData = this.preparePostData();
          if (this.invoiceId || this.formData.objectId) {
            await this.$store.dispatch("invoice/updateInvoice", postData);
            await this.initData();
          } else {
            let create;
            if (this.documentType == 7 || this.documentType == 8) {
              if (this.booking) postData.bookingId = this.booking.objectId;
              create = await this.$store.dispatch(
                "invoice/createBookingInvoice",
                postData
              );
              if (this.booking) {
                if (this.booking.invoices.length) {
                  this.booking.invoices.push(create);
                } else {
                  this.booking.invoices = [create];
                }
                await this.$store.dispatch("booking/editBooking", {
                  id: this.booking.objectId,
                  invoiceIds:
                    this.booking.invoices && this.booking.invoices.length
                      ? this.booking.invoices.map(iv => iv.objectId)
                      : []
                });
              }
            } else {
              create = await this.$store.dispatch(
                "invoice/createInvoice",
                postData
              );
            }
            this.formData.objectId = create.objectId;
            await this.initData();
          }
          this.$emit("onSaveSuccess", this.invoice);

          this.isSaving = false;
          this.isSuccess = true;
          return true;
        } catch (error) {
          console.log("error", error);
          this.isSaving = false;
          this.isError = true;
        }
      }
    },
    deleteItem(index) {
      this.formData.items.splice(index, 1);
    },
    addItem(documentItem = null) {
      this.formData.items.push(
        documentItem
          ? documentItem
          : new DocumentItem(
            { area: { isRemove: true, name: "-" } },
            this.formData.isVatInclusive,
            this.formData.vatPercent,
            this.project ? this.project.code : null
          )
      );
    },
    chooseItem(product, index) {
      this.formData.items[index].quantity = 1;
      this.formData.items[index].name = product.name;
      this.formData.items[index].unit = product.unit;
      this.formData.items[index].sellVatType = product.sellVatType;
      this.formData.items[index].type = product.type;
      this.formData.items[index].discountType = 1;
      this.formData.items[index].originalPricePerUnit = 0;
      this.formData.items[index].discountPerUnit = 0;
      if (product.type == "discount") {
        this.formData.items[index].originalPricePerUnit = 0;
      }
      if (this.customerType == "company") {
        if (this.market && this.market.disableWht) {
          this.formData.items[index].whtPercent = 0;
        } else {
          this.formData.items[index].whtPercent = product.whtPercent || 0;
        }
      } else {
        this.formData.items[index].whtPercent = 0;
      }
      if (!this.formData.items[index].area?.isRemove) {
        let area = this.formData.items[index].area;
        let areaAccountingProduct = this.areaAccountingProducts.find(
          d =>
            d.area.objectId == area.objectId &&
            d.accountingProduct.objectId == product.objectId &&
            d.currencyCode == this.formData.currencyCode
        );
        if (areaAccountingProduct) {
          this.formData.items[index].originalPricePerUnit = areaAccountingProduct.cost || 0;
          this.formData.items[index].discountPerUnit = areaAccountingProduct.discount || 0;
          this.formData.items[index].discountType = areaAccountingProduct.discountType || 0;
        }
      }
      if (product.objectId) {
        this.formData.items[index].accountingProduct = {
          className: "AccountingProduct",
          objectId: product.objectId,
          __type: "Pointer"
        };
      }
    },
    chooseArea(index) {
      if (
        this.formData.items[index].accountingProduct &&
        !this.formData.items[index].area?.isRemove &&
        !this.formData.items[index].refInvoiceBooking
      ) {
        let area = this.formData.items[index].area;
        let accountingProduct = this.formData.items[index].accountingProduct;

        let areaAccountingProduct = this.areaAccountingProducts.find(
          d =>
            d.area.objectId == area.objectId &&
            d.accountingProduct.objectId == accountingProduct.objectId &&
            d.currencyCode == this.formData.currencyCode
        );
        if (areaAccountingProduct) {
          this.formData.items[index].originalPricePerUnit = areaAccountingProduct.cost || 0;
          this.formData.items[index].discountPerUnit = areaAccountingProduct.discount || 0;
          this.formData.items[index].discountType = areaAccountingProduct.discountType || 0;
        }
      }
    },
    addItems(items) {
      if (
        items &&
        items.length &&
        this.formData.items.length == 1 &&
        !this.formData.items[0].accountingProduct
      ) {
        this.formData.items = [];
      }
      for (let item of items) {
        this.formData.items.push(
          new DocumentItem(
            item,
            this.formData.isVatInclusive,
            this.formData.vatPercent,
            this.project ? this.project.code : null
          )
        );
      }
    },
    addTels() {
      this.formData.tels.push("");
    },
    addEmails() {
      this.formData.emails.push("");
    },
    dismiss() {
      if (this.isChange) this.isConfirmDialog = true;
      else this.$emit("onDismiss", true);
    },
    addProduct() {
      this.isDialogAccountingProduct = true;
    },
    async onOkConfirmDialog() {
      this.isConfirmDialog = false;
      try {
        let d = await this.saveInvoice();
        if (d) this.$emit("onDismiss", true);
      } catch (err) { }
    },
    onCancelConfirmDialog() {
      this.$emit("onDismiss", true);
    },
    async sendInvoce() {
      this.isLoading = true;
      try {
        let postData = this.preparePostData();
        if (
          this.invoiceId &&
          this.invoice &&
          (this.invoice.penaltyItem ||
            (this.invoice.penaltyItems && this.invoice.penaltyItems.length > 0))
        ) {
          await this.$store.dispatch("invoice/updateInvoice", postData);
        }
        await this.$store.dispatch("invoice/sendInvoice", {
          id: this.formData.objectId,
          date: this.$moment(this.invDate)
            .startOf("day")
            .toDate(),
          dueDate: this.$moment(this.invDueDate)
            .endOf("day")
            .toDate()
        });

        await this.initData();
        this.$emit("onSaveSuccess", this.invoice);
        this.$eventBus.$emit('updateAreaPlan')
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    async onOkUnsendConfirmDialog() {
      this.isLoading = true;
      try {
        await this.$store.dispatch(
          "invoice/unsendInvoice",
          this.formData.objectId
        );
        await this.initData();
        let invoice = this.invoice;
        invoice.isUnSendSuccess = true;
        this.$emit("onSaveSuccess", invoice);
        this.$emit("onUnSendSuccess");
        this.$eventBus.$emit('updateAreaPlan')
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    async onSaveSuccessPayment(data) {
      this.isSaving = true;
      try {
        if (data.paymentMethod != 7) {
          let receipt = this.tempReceipt;
          let amount = 0;

          if (data.amount > 0) {
            amount = data.amount;
          }

          let paymentData = {
            date: data.date,
            paymentMethod: data.paymentMethod,
            paymentBankAccount: data.paymentBankAccount,
            paymentNote: data.paymentNote,
            paymentProofFiles: data.paymentProofFiles,
            paymentCurrencyCode: data.paymentCurrencyCode,
            totalPaymentValue: data.totalPaymentValue,
            exchangeRate: data.exchangeRate,
            voucherNumber: data.voucherNumber
          };

          if (!receipt && !this.invoice.totalPaidValue && data.isSplitVatNonVat && data.paymentType == "full") {
            let invoices = []
            if (this.invoice.items.filter(d => d.sellVatType == 1).length) {
              invoices.push(
                new Invoice({
                  ...this.invoice,
                  items: this.invoice.items.filter(d => d.sellVatType == 1)
                })
              )
            }
            if (this.invoice.items.filter(d => d.sellVatType != 1).length) {
              invoices.push(
                new Invoice({
                  ...this.invoice,
                  items: this.invoice.items.filter(d => d.sellVatType != 1)
                })
              )
            }

            invoices = invoices.sort((a, b) => {
              if (b.totalValue > a.totalValue) return -1
              else return 1
            })

            for (let invoice of invoices) {
              let receipt = await this.$store.dispatch("receipt/createReceipt", {
                invoiceId: this.invoice.objectId,
                items: invoice.items,
                isVatInclusive: invoice.isVatInclusive,
                totalValue: invoice.totalValue,
                totalVatValue: invoice.totalVatValue,
                totalNonVatValue: invoice.totalNonVatValue,
                totalVatItemsValue: invoice.totalVatItemsValue,
                totalNonVatItemsValue: invoice.totalNonVatItemsValue,
                totalWhtValue: invoice.totalWhtValue,
                totalDiscountValue: invoice.totalDiscountValue,
                currencyCode: invoice.currencyCode
              });
              if (receipt) paymentData.id = receipt.objectId;
              await this.$store.dispatch("receipt/payReceipt", paymentData);
            }
          } else {
            if (!receipt) {
              receipt = await this.$store.dispatch("receipt/createReceipt", {
                invoiceId: this.formData.objectId,
                amount,
                items: data.items,
                isVatInclusive: data.isVatInclusive,
                totalValue: data.totalValue,
                totalVatValue: data.totalVatValue,
                totalNonVatValue: data.totalNonVatValue,
                totalVatItemsValue: data.totalVatItemsValue,
                totalNonVatItemsValue: data.totalNonVatItemsValue,
                totalWhtValue: data.totalWhtValue,
                totalDiscountValue: data.totalDiscountValue,
                currencyCode: data.currencyCode
              });
            }
            if (receipt) paymentData.id = receipt.objectId;
            await this.$store.dispatch("receipt/payReceipt", paymentData);
          }
        }
        await this.initData();
        this.$emit("onSaveSuccess", this.invoice);
        this.$eventBus.$emit('updateAreaPlan')
        this.isSaving = false;
        this.isSuccess = true;
        return true;
      } catch (error) {
        this.isSaving = false;
        this.isError = true;
      }
    },
    async onOkUnpaidConfirmDialog({ note }) {
      this.isSaving = true;
      try {
        let receipt = await this.$store.dispatch("receipt/unpaidReceipt", {
          id: this.tempReceipt.objectId,
          note
        });
        if (receipt.paymentMethod == 7) {
          this.$toast.show({
            content: this.$t('bill.cancel_success_please_check_refund_status_from_bill_status_history'),
            color: "success"
          });
        } else {
          this.$toast.show({
            content: this.$t('cancel_success'),
            color: "success"
          });
        }
        await this.initData();
        this.$emit("onSaveSuccess", this.invoice);
        this.$eventBus.$emit('updateAreaPlan')
        this.isSaving = false;
        return true;
      } catch (error) {
        this.isSaving = false;
        this.isError = true;
      }
    },
    async onOkSendConfirmDialog() {
      await this.sendInvoce();
    },
    async reCalculate() {
      this.isLoading = true;
      try {
        await Invoice.reCalculateMonthlyInvoice(this.formData.objectId);
        await this.initData();
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    reCalculateCreate() {
      const newObject = JSON.parse(JSON.stringify(this.formData));
      this.formData = new Invoice(newObject);
      this.formData.date = newObject.date
        ? this.$moment(newObject.date).toISOString()
        : null;
      this.formData.dueDate = newObject.dueDate
        ? this.$moment(newObject.dueDate).toISOString()
        : null;
    },
    payInvoice() {
      this.tempInvoice = this.invoice;
      this.tempReceipt = null;
      this.tempInvoicePayment = null;
      if (this.invoice && this.invoice.invoicePayment) {
        this.tempInvoicePayment = this.invoice.invoicePayment;
      }
      this.isPaymentFormDialog = true;
    },
    payReceipt(receipt) {
      this.tempInvoice = null;
      this.tempReceipt = receipt;
      this.isPaymentFormDialog = true;
    },
    unpaidReceip(receipt) {
      this.tempReceipt = receipt;
      this.isUnpaidConfirmDialog = true;
    },
    viewReceipt(receipt) {
      this.tempReceipt = receipt;
      this.isReceiptDialog = true;
    },
    async onOkRemoveConfirmDialog() {
      this.isLoading = true;
      try {
        if (this.formData.objectId) {
          await this.$store.dispatch(
            "invoice/removeInvoice",
            this.formData.objectId
          );
          this.$emit("onRemoveSuccess");
        }
        this.isLoading = false;
        this.$emit("onDismiss", true);
      } catch (err) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    async onOkCancelInvoice() {
      this.isLoading = true;
      try {
        if (this.formData.objectId) {
          await this.$store.dispatch(
            "invoice/cancelInvoice",
            this.formData.objectId
          );
        }
        await this.initData();
        this.$emit("onSaveSuccess", this.invoice);
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    async onSaveSuccessBillHeder() {
      this.isLoading = true;
      try {
        await this.initData();
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    async onCancelInvoicePayment() {
      this.isLoading = true;
      try {
        await Invoice.cancelInvoiceInvoicePayment(this.invoice.objectId);
        await this.initData();
        this.$emit("onSaveSuccess", this.invoice);
        this.isLoading = false;
        this.isCancelSuccess = true;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
        this.isError = true;
      }
    },
    onChangeDate() {
      if (!this.isDisableCreditTerm) {
        this.invDueDate = this.$moment(this.invDate)
          .add(this.creditTerm, "days")
          .toISOString()
        this.menuDate = false
      }
    },
    onSuccessChooseProductAndAreas(data) {
      for (let area of data.areas) {
        this.formData.items.push(new DocumentItem(
          { area: area },
          this.formData.isVatInclusive,
          this.formData.vatPercent,
          this.project ? this.project.code : null
        ))
        this.chooseItem(data.accountingProduct, this.formData.items.length - 1)
      }
    },
    onSuccessChooseAccountingProductAndInvoice(data) {
      if (data && data.accountingProduct && data.invoice) {
        let isDuplicate = false
        if (this.formData.items?.length && data.invoice?.objectId)
          for (const item of this.formData.items) {
            if (item.refInvoiceBooking?.objectId == data.invoice.objectId) {
              isDuplicate = true
              break;
            }
          }

        if (!isDuplicate) {
          this.formData.items.push(
            new DocumentItem(
              { area: { isRemove: true, name: "-" } },
              data.invoice.isVatInclusive,
              data.invoice.vatPercent,
              this.project ? this.project.code : null
            )
          );
          this.chooseItem(data.accountingProduct, this.formData.items.length - 1)
          this.formData.items[this.formData.items.length - 1].discountPerUnit = data.invoice.totalValue
          this.formData.items[this.formData.items.length - 1].detail = `${this.$t('booking.reference_booking_invoice')} : ${data.invoice.documentId}`
          this.formData.items[this.formData.items.length - 1].sellVatType = 3
          this.formData.items[this.formData.items.length - 1].refInvoiceBooking = data.invoice
          // this.formData.refInvoiceBooking.push(data.invoice)
        } else {
          this.$toast.show({
            content: this.$t('booking.error_booking_bill_already_used'),
            color: "error"
          });
        }
      }
    },
    async checkFormValidate(func) {
      if (this.$refs.form.validate() && !this.formData.items.find(d => this.isDuplicateItem(d))) {
        if (
          this.formData.items.find(d => d.type == "discount" && !d.discountPerUnit) ||
          this.formData.items.find(d => d.type != "discount" && !d.originalPricePerUnit)
        ) {
          this.isConfirmSaveDialog = true
          this.tempCallbackFunc = func
        } else {
          func()
        }
      }
    },
    isDuplicateItem(item) {
      if (item.accountingProduct && item.area) {
        return this.formData.items
          .filter(d =>
            d.accountingProduct?.objectId == item.accountingProduct?.objectId &&
            d.area?.objectId == item.area?.objectId &&
            d.billingSetting?.objectId == item.billingSetting?.objectId
          )
          .length > 1
      }
    },
    onWriteData(dataTax) {
      if (this.customerType == 'company' && dataTax) {
        this.formData.customerData.name = dataTax.companyName
        this.formData.customerData.address = dataTax.fullAddress
        // this.$forceUpdate();
        // this.form.addressStreet = dataTax.addressStreet;
        // this.form.addressSubDistrict = dataTax.Thambol;
        // this.form.addressDistrict = dataTax.Amphur;
        // this.form.addressProvince = dataTax.Province;
        // this.form.addressZipcode = dataTax.PostCode;
      }
    },
    printClick(lang) {
      this.printLang = lang
      this.isPrintDialog = true
    },
    async checkoutPaymentDialog(item) {
      this.tempCheckout = item
      this.isCheckoutPayment = true;
    },
    isContractCheckOuts(mode) {
      let res = false
      if (this.formData.contractCheckOuts && this.formData.contractCheckOuts.length) {
        if (this.formData.documentType == 2 || mode == "edit") {
          res = true
        } else {
          if (this.formData.contractCheckOuts.find(d => !d.isPaid || d.status == "draft" || d.status == "pending")) {
            res = true
          } else {
            res = false
          }
        }
      }
      return res
    },
    onChangeCurrencyCode(value) {
      if (this.formData.items && this.formData.items.length) {
        this.formData.items = this.formData.items.filter(item => {
          if (item.refInvoiceBooking && item.refInvoiceBooking.currencyCode) {
            return item.refInvoiceBooking.currencyCode === value
          }
          return true
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}

.tool-bar {
  position: fixed;
  height: 70px;
  background-color: rgb(0, 166, 80);
  color: white;
}

.table-item.header {
  background-color: rgb(0, 166, 80);

  th {
    color: white !important;
    font-size: 15px;
  }
}

.summary-topic {
  margin: 5px 0;
  color: rgb(0, 166, 80);
  font-weight: 400;

  &.bold {
    font-weight: 600;
  }
}

.summary-number {
  margin: 5px 0;
  font-weight: 500;

  &.bold {
    font-weight: 700;
  }
}

.rounded-t {
  border-radius: 15px 15px 0 0 !important;
}

.rounded-b {
  border-radius: 0 0 15px 15px !important;
}

.rounded-none {
  border-radius: 0 !important;
}

.vertical-top {
  vertical-align: top !important;
}

.card-receipt-form {
  height: calc(100vh - 135px);
  overflow-y: scroll;
  overflow-x: hidden;
}

.receipt-note {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  color: var(--v-success-base);
  // border: 1px solid red;
}

.icon-currency{
  border-radius: 50%;
  margin-top: 3px;
}

.icon-currency-avatar{
  height: 20px !important;
  min-width: 20px !important;
  width: 20px !important;
  margin-right: 5px !important;
}

</style>
<style>
.small-radio label {
  font-size: 14px;
}
</style>